// src/firebase/SavePromptModal.jsx
import { useState } from "react";
import { useAuth } from "./useAuth";

export function SavePromptModal({ onClose, onSuccess }) {
  const { upgradeWithGoogle, upgradeWithEmail } = useAuth();
  const [mode, setMode] = useState("choose");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleGoogle = async () => {
    setLoading(true);
    try {
      await upgradeWithGoogle();
      onSuccess?.();
      onClose();
    } catch (e) {
      setError("Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  const handleEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await upgradeWithEmail(email, password);
      onSuccess?.();
      onClose();
    } catch (e) {
      setError(e.message);
    }
    setLoading(false);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button style={styles.close} onClick={onClose}>✕</button>
        <h2 style={styles.title}>Save your work</h2>
        <p style={styles.subtitle}>
          Create a free account to save everything you've filled out. It'll all still be here.
        </p>
        {mode === "choose" && (
          <div style={styles.buttons}>
            <button style={styles.googleBtn} onClick={handleGoogle} disabled={loading}>
              Continue with Google
            </button>
            <button style={styles.emailBtn} onClick={() => setMode("email")} disabled={loading}>
              Continue with Email
            </button>
          </div>
        )}
        {mode === "email" && (
          <form onSubmit={handleEmail} style={styles.form}>
            <input style={styles.input} type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} required />
            <input style={styles.input} type="password" placeholder="Create a password" value={password} onChange={(e) => setPassword(e.target.value)} required />
            {error && <p style={styles.error}>{error}</p>}
            <button style={styles.googleBtn} type="submit" disabled={loading}>
              {loading ? "Saving..." : "Create account & save"}
            </button>
            <button style={styles.back} type="button" onClick={() => setMode("choose")}>← Back</button>
          </form>
        )}
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 },
  modal: { background: "#fff", borderRadius: 12, padding: 40, maxWidth: 400, width: "90%", position: "relative", boxShadow: "0 20px 60px rgba(0,0,0,0.2)" },
  close: { position: "absolute", top: 16, right: 16, background: "none", border: "none", fontSize: 18, cursor: "pointer", color: "#999" },
  title: { fontSize: 24, fontWeight: 700, marginBottom: 8 },
  subtitle: { color: "#666", marginBottom: 24, lineHeight: 1.5 },
  buttons: { display: "flex", flexDirection: "column", gap: 12 },
  googleBtn: { padding: "14px 20px", background: "#000", color: "#fff", border: "none", borderRadius: 8, fontSize: 16, cursor: "pointer", fontWeight: 600 },
  emailBtn: { padding: "14px 20px", background: "#fff", color: "#000", border: "2px solid #000", borderRadius: 8, fontSize: 16, cursor: "pointer", fontWeight: 600 },
  form: { display: "flex", flexDirection: "column", gap: 12 },
  input: { padding: "14px 16px", border: "2px solid #e5e5e5", borderRadius: 8, fontSize: 16, outline: "none" },
  error: { color: "red", fontSize: 14 },
  back: { background: "none", border: "none", cursor: "pointer", color: "#666", fontSize: 14 },
};
